import {
  type IndustrialPremises,
  type IndustrialPremisesRevenueRow,
} from '@pigello/pigello-matrix';
import { createBaseRentHandler } from './shared-base-rent-handler';
import { withBuildingRealEstate } from './shared-building-realestate';

const baseHandler = createBaseRentHandler<
  IndustrialPremises,
  IndustrialPremisesRevenueRow
>('industrialpremisesrevenuerow');

export async function handleCustomIndustrialPremisesNestedCase(
  listResponse: Parameters<typeof baseHandler>[0]
) {
  const withRevenue = await baseHandler(listResponse);
  return withBuildingRealEstate(withRevenue);
}
